import { MessageActionButton } from '@shared/scenes/chat/thread/components/message/bubble/components/MessageActionButton';
import { grid } from '@shared/styles';

export interface ReactionButtonProps {
  onClick: () => void;
  testID?: string;
}

export function ReactionButton({ onClick, testID }: ReactionButtonProps) {
  return (
    <MessageActionButton
      onPress={onClick}
      icon="add-reactions"
      iconSize={grid(4.75)}
      testID={testID}
    />
  );
}
